import {Table, Tag, Empty, Spin} from "antd";
import {renderDate, numberFormat} from "~/utils";
import "../../style/OrderTable.scss";

function OrderDetail({record, details, isLoading, appData})
{
    const detailColumns = [
        {
            title: 'Mã hàng',
            dataIndex: 'code',
            key: 'code',
            width: '120px',
        },
        {
            title: 'Tên hàng',
            dataIndex: 'title',
            key: 'title',
            width: '300px',
            render: (_, item) => (
                <div>
                    <p className="mb-0">{item.title} {item.attribute_label && <span className="fw-bold color-blue">{item.attribute_label}</span>}</p>
                </div>
            )
        },
        {
            title: 'Số lượng',
            dataIndex: 'quantity',
            key: 'quantity',
            width: '120px',
            render: (_, item) => (
                (item.unit === 'kg') ? Number(item.quantity/1000).toFixed(2) : item.quantity
            )
        },
        {
            title: 'Đơn vị',
            dataIndex: 'unit',
            key: 'unit',
            width: '100px',
        },
        {
            title: 'Giá bán',
            dataIndex: 'price',
            key: 'price',
            width: '120px',
            render: (price, item) => (
                <div>{numberFormat(price)} đ{item.unit === 'kg' ? '/0.1kg' : ''}</div>
            )
        },
        {
            title: 'VAT (%)',
            dataIndex: 'vat',
            key: 'vat',
            width: '100px',
            render: (vat) => `${vat}%`
        },
        {
            title: 'Thành tiền',
            dataIndex: 'subtotal',
            key: 'subtotal',
            width: '150px',
            render: (subtotal) => <b>{numberFormat(subtotal)} đ</b>
        },
    ];

    const statusInfo = appData?.['orderStatus']?.[record.status] || { badge: 'default', label: record.status};

    return (
        <div className="order-details">
            <div className="order-header">
                <div className="order-header-left">
                    <div className="order-code">{record.code}</div>
                    {record.status && <Tag color={statusInfo.badge}>{statusInfo.label}</Tag>}
                </div>
            </div>
            <div className="order-meta mb-3">
                {record.user_created_name && <span>Người tạo: <b>{record.user_created_name}</b></span>}
                {record.created && <span>Ngày bán: <b>{record.created}</b></span>}
                {record.customer_name && <span>Khách hàng: <b>{record.customer_name}</b></span>}
                {record.customer_phone && <span>SĐT: <b>{record.customer_phone}</b></span>}
            </div>
            <div className="order-table">
                <Spin spinning={isLoading}>
                    {!details.items || details.items.length === 0 ? (
                        <Empty description="Chưa có chi tiết" />
                    ) : (
                        <Table
                            columns={detailColumns}
                            dataSource={details.items.map((detail, index) => ({
                                key: detail.id || index,
                                ...detail
                            }))}
                            pagination={false}
                            size="small"
                        />
                    )}
                </Spin>
            </div>
            <div className="order-totals">
                <div className="order-total-row">
                    <span>Tổng tiền hàng</span>
                    <b>{numberFormat(record.subtotal)} đ</b>
                </div>
                <div className="order-total-row">
                    <span>Giảm giá hóa đơn</span>
                    <b className="color-red">-{numberFormat(record.discount)} đ</b>
                </div>
                <div className="order-total-row">
                    <span>VAT</span>
                    <b>{numberFormat(record.vat)} đ</b>
                </div>
                <div className="order-total-row">
                    <span>Khách cần trả</span>
                    <b className="color-blue">{numberFormat(record.total)} đ</b>
                </div>
                <div className="order-total-row">
                    <span>Khách đã trả</span>
                    <b className="color-green">{numberFormat(record.paid)} đ</b>
                </div>
            </div>
        </div>
    );
}

export default OrderDetail;
